import type { BreadcrumbConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Deal } from "@/lib/types/database/deals";

export const dealDetailBreadcrumbs: BreadcrumbConfig = {
  show: true,
  items: [
    {
      label: "Deals",
      href: "/deals",
    },
    {
      label: "Deal Details",
      href: (item: any) => `/deals/${(item as Deal).id}`,
      current: true,
    },
  ],
};
